import BaseClient from '@/app/model/api/response/baseApiClient'

class PlantDeleteApi extends BaseClient {
  public doPlantDelete (id: string) {
    const path: string = '/v1/plantings/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new PlantDeleteApi()
